<template>
    <div style="height:100%">
        <div id="container">
            <div class="toolbar">
                <input type="button" value="选取观察位置"  class="btn btn-primary" @click="chooseview()">
                <input type="button" value="添加目标点"  class="btn btn-primary" @click="addpoint()">
                <input type="button" value="清除"  class="btn btn-primary" @click="dele()">
            </div>
        </div>
        <div id="loadingOverlay"><h1>Loading........</h1></div>
    </div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {
         viewer:null,
         viewpoints:[],
         destPoints:[],
         arrEntity:[],
         startposition:null
        }
    },
    mounted(){
      var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
        this.init()
    },
    methods:{
        init() {
        this.viewer=util.getViewer('container',{
             terrainProvider: Cesium.createWorldTerrain({
                    requestWaterMask: true,
                    requestVertexNormals: true
             })
          });
            this.viewer.scene.globe.depthTestAgainstTerrain = true;
            this.viewer.camera.setView({
                    destination: new Cesium.Cartesian3(-422509.3951482099, 5532360.212984754, 3150487.761115421),
                    orientation: {
                        heading: 4.9473997814211685,
                        pitch: -0.2144357483381767,
                        roll: 6.2803097428980585
                    }
                });
        },

        //******选取观察位置******//
        chooseview() {
            this.viewer.entities.removeAll();
            this.viewpoints=[];
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
              handler.setInputAction((event)=>{
                var ray = this.viewer.camera.getPickRay(event.position);
                var earthPosition = this.viewer.scene.globe.pick(ray, this.viewer.scene);
                this.startposition=earthPosition;
       
                var point1=this.viewer.entities.add({
                    position:earthPosition,
                    point:{
                        color : Cesium.Color.YELLOW,
                        pixelSize : 10,
                       }
                });
                let ab12 = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(earthPosition);
                let a = Cesium.Math.toDegrees(ab12.latitude);
                let b =  Cesium.Math.toDegrees(ab12.longitude);
                this.viewpoints.push(b,a);
                handler.destroy();
              },Cesium.ScreenSpaceEventType.LEFT_CLICK);
             
        },

        //******添加目标点******//
        addpoint(){
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
              handler.setInputAction((event)=>{
                var s = this.viewer.camera.getPickRay(event.position);
                var earthPosition = this.viewer.scene.globe.pick(s, this.viewer.scene);
                var point2=this.viewer.entities.add({
                    position:earthPosition,
                    point:{
                        color : Cesium.Color.YELLOW,
                        pixelSize : 10,
                       }
                });
            
                let cd = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(earthPosition);
                let c = Cesium.Math.toDegrees(cd.latitude);
                let d =  Cesium.Math.toDegrees(cd.longitude);
                this.viewpoints.push(d,c);

                handler.destroy();
                var cartesianStart=this.startposition;
                var cartesianEnd=earthPosition;
                let subtract = Cesium.Cartesian3.subtract(cartesianEnd, cartesianStart, new Cesium.Cartesian3());
                // 计算射线的方向，目标点left 视域点right
                let direction = Cesium.Cartesian3.normalize(subtract, new Cesium.Cartesian3());
                // 建立射线
                let ray = new Cesium.Ray(cartesianStart, direction);
                let result = this.viewer.scene.pickFromRay(ray); // 计算交互点，返回第一个

                if (result != null && result.position != null) {
                    this._makeLine([cartesianStart,  result.position],Cesium.Color.GREEN);//可视区域
                    this._makeLine([result.position,  cartesianEnd],Cesium.Color.RED);//不可视区域
                } else {
                    alert("没有计算出来，请把视野调整到点的后面")
                }
              
              },Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },
        showIntersection(result, destPoint, viewPoint){
                
        },
       _makeLine(arrCarte3,color){
          var lines= this.viewer.entities.add({
                    polyline:{
                    positions : arrCarte3,
                    // clampToGround : true,
                    width : 2,
                    material:color
                   }
                });
       },
        dele() {
            this.viewer.entities.removeAll();
        }
    }
}
</script>
<style scoped>
  #container{
    height: 100%;
  }
   .toolbar{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    border: 1px solid #526f82;
    width: 330px;
    height: 60px;
    top: 10px;
    left: 10px;
    padding: 10px 15px;
    color: #ffffff;
    box-shadow: 0 3px 14px rgba(128,128,128,.5);
    z-index: 100;
  }
  .form-control{
    color: #fff;
    background-color: rgba(63,72,84,.7);
    border: none;
  }
  .btn-primary{
    height: 30px;
    padding: 0px 15px 0px 15px;
    color:#fff;
    background-color: rgba(32,160,255,.2);
    cursor: pointer;
    margin: 4px 2px 0px 2px;
    border: 1px solid #e4eaec;
    border-radius: 3px;
    box-shadow: 0 1px 2px #8b8b8b inset, 0 -1px 0 #3d3d3d inset, 0 -2px 3px #8b8b8b inset;
  }
</style>